<template>
  <div class="app-bar">
    <p class="title">{{ getOrganizationTitle() }}</p>
    <v-spacer />
    <div class="user">
      <img
        style="margin-right: 15px"
        class="app-bar-icon"
        src="@/assets/svg/user-icon.svg"
        alt="user icon"
      />
      <div class="user-inner">
        <p class="user-login">
          {{ profile.first_name }} {{ profile.last_name }}
        </p>
        <p class="user-role">{{ profile.role }}</p>
      </div>
      <v-btn style="margin-left: 15px" icon @click="routeToMyProfile()">
        <img
          class="app-bar-icon"
          src="@/assets/svg/more-icon.svg"
          alt="more button"
        />
      </v-btn>
      <v-btn style="margin-left: 15px" icon @click="routerToSettings()">
        <v-icon>mdi-cog-outline</v-icon>
      </v-btn>
    </div>
    <v-btn icon @click="logout">
      <img
        class="app-bar-icon"
        src="@/assets/svg/logout-icon.svg"
        alt="logout button"
      />
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "AppBar",
  data() {
    return {
      profile: "",
    };
  },
  methods: {
    async getProfile() {
      try {
        const response = await this.$axios.get("/users/myprofile/");
        this.profile = response.data;
        this.$store.commit("saveUserProfile", response.data);
      } catch (e) {
        this.$root.$emit(
          "showCustomError",
          "Ошибка во время получении информации по профилю"
        );
      }
    },
    getOrganizationTitle() {
      return this.profile.organization?.title;
    },
    routeToMyProfile() {
      this.$router.push({ name: "my-profile" });
    },

    routerToSettings() {
      this.$router.push({ name: "Settings" });
    },

    logout() {
      this.$store.dispatch("removeTokens").then(() => {
        this.$router.push({ name: "login" });
      });
    },
  },
  created() {
    this.getProfile();
  },
};
</script>

<style scoped lang="scss">
.app-bar {
  margin-bottom: 37px;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  height: 60px;
  background-color: #ffffff;

  display: flex;
  flex-direction: row;
  align-items: center;

  .app-bar-icon {
    height: 20px;
    width: 20px;
  }

  .title {
    font-family: "Gilroy-Light", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    color: #0b3954;
  }

  .user {
    margin-right: 40px;
    height: 39px;

    display: flex;
    flex-direction: row;
    align-items: center;

    font-family: "Gilroy-Medium", sans-serif;
    font-style: normal;
    font-weight: 500;

    .user-login {
      font-size: 18px;
      line-height: 21px;
      color: #0b3954;
    }
    .user-role {
      font-size: 15px;
      line-height: 18px;
      color: #d2d1cd;
    }
  }
}
</style>
